import React, { useCallback, useEffect, useState } from 'react';
import styles from './TrainingList.module.css';
import { CustomCardList, CustomFooter, CustomLoader, CustomMoreSection, CustomNoData, CustomPagination, CustomTextMarkdown, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { getTrainingContent } from '../../../services/contentService';
import { getTrainingList } from '../../../services/trainingService';
import { useNavigate } from 'react-router-dom';

const TrainingList = () => {

    const ELEMENTS_BY_PAGE = 12;

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isTrainingsLoading, setIsTrainingsLoading] = useState<boolean>(true);
    const [pageNumber, setPageNumber] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(0);

    const [pageContent, setPageContent] = useState<any>(null);
    const [trainingsList, setTrainingsList] = useState<any>([]);

    const handleGetContent = async () => {
        setIsLoading(true);
        
        const content = await getTrainingContent();
        
        setPageContent(content);
        setIsLoading(false);
    }

    const handleGetTrainings = useCallback(async () => {
        setIsTrainingsLoading(true);

        const res = await getTrainingList(currentPage*ELEMENTS_BY_PAGE, ELEMENTS_BY_PAGE);
        const formatedTrainingList = res.data.map((item: any) => {
            const el: CustomCardType = {
                documentId: item.documentId,
                title: item.title,
                image: item.image,
                description: item.content,
                likes: [],
                isLiked: false
            }
            return el;
        });

        setPageNumber(Math.ceil(res.meta.pagination.total / ELEMENTS_BY_PAGE))
        setTrainingsList(formatedTrainingList);
        setIsTrainingsLoading(false);
    }, [currentPage]);

    useEffect(() => {
        handleGetContent();
        handleGetTrainings();
    }, [handleGetTrainings]);

    const goToTrainingPage = (trainingId: string) => {
        navigate(`/training/${trainingId}`);
    }

    const handleShareTraining = async (url: string, title: string, description: string) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: title,
                    text: description,
                    url: `${process.env.REACT_APP_API_BASE_URL}/training/${url}`,
                });
            } catch (error) {
                console.error(error);
            }
        } else {
            alert(t('store.share_not_allowed'));
        }
    }

    return (
        <div className={styles.container}>
            { !isLoading &&
                <>
                    <div className={styles.A_block}>
                        <CustomTitle isSubtitle className={styles.subtitle}>{pageContent.subtitle}</CustomTitle>
                        <CustomTitle center>{pageContent.title}</CustomTitle>
                        <CustomTextMarkdown className={styles.paragraph}>{pageContent.paragraph}</CustomTextMarkdown>
                    </div>

                    <div className={styles.training_container}>
                        { !isTrainingsLoading &&
                            <>
                                <CustomCardList
                                    imagesAlt=""
                                    list={trainingsList}
                                    onClick={goToTrainingPage}
                                    onShare={handleShareTraining}
                                    hoverText={t('training.see_training')}
                                />

                                { trainingsList.length === 0 &&
                                    <CustomNoData message={t('training.no_data')} />
                                }
                            </>
                        }

                        { isTrainingsLoading &&
                            <div className={styles.container_loader}>
                                <CustomLoader loaderType="skeleton" isLoading={isTrainingsLoading}/>
                            </div>
                        }

                        { pageNumber > 1 &&
                            <CustomPagination
                                currentPage={currentPage}
                                setPage={setCurrentPage}
                                pageNumber={pageNumber}
                                isLoading={isTrainingsLoading}
                            />
                        }
                    </div>

                    <CustomMoreSection />
                    <CustomFooter />
                </>
            }

            { isLoading &&
                <div className={styles.container_loader}>
                    <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
                </div>
            }
        </div>
    )
}

export default TrainingList;